export default __webpack_public_path__ + "static/media/walking.79d196f9.svg";